import { ConfigurationEmailResponse } from '../../../Monitor/types';

export const EmptyEmailObject: ConfigurationEmailResponse = {
  id: '',
  name: '',
  email: '',
  monitorDetails: [],
  language: '',
};
